import * as React from "react";
import classnames from "classnames";

import { Button } from "reactstrap";
import DatePicker from "react-datepicker";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const moment = require("moment");

export interface DatePickerCardProps {
  title: string;
  error?: string;
  value?: string;
  dateFormat?: string;
  cardClassName?: string;
  onChange: (value?: Date) => void;
  type?: "date" | "time" | "date-time";
}

export interface DatePickerCardState {
  open: boolean;
}

class DatePickerCard extends React.PureComponent<
  DatePickerCardProps,
  DatePickerCardState
> {
  static defaultProps = {
    type: "date",
  };

  state: DatePickerCardState = {
    open: false,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  get dateFormat() {
    const { type, dateFormat } = this.props;

    if (dateFormat) {
      return dateFormat;
    }

    if (type === "date") {
      return "MM/DD/YYYY";
    } else if (type === "date-time") {
      return "MM/DD/YYYY hh:mm A";
    }

    return "hh:mm A";
  }

  handleChange(value) {
    const { type, onChange } = this.props;

    onChange(value);
    this.setState({ open: false });
  }

  renderDatePicker() {
    const { open } = this.state;
    const { type, value } = this.props;

    const showTimeSelectOnly = type === "time";
    const showTimeSelect = showTimeSelectOnly || type === "date-time";

    return (
      <DatePicker
        open={open}
        className="d-none"
        popperPlacement="bottom"
        onChange={this.handleChange}
        showTimeSelect={showTimeSelect}
        showTimeSelectOnly={showTimeSelectOnly}
        selected={value ? new Date(value) : undefined}
        popperClassName={classnames({ "-open": open })}
        onClickOutside={() => this.setState({ open: false })}
      />
    );
  }

  renderSelectButton() {
    const { open } = this.state;
    const { type, value } = this.props;

    let formattedValue;
    if (value) {
      formattedValue = moment(value).format(this.dateFormat);
    }

    const buttonTitle = formattedValue
      ? formattedValue
      : type === "date" || type === "date-time"
      ? "Select date"
      : "Select time";
    return (
      <div style={{ position: "relative" }}>
        {this.renderDatePicker()}

        <Button
          color="primary"
          className="font-weight-bold w-100"
          onClick={() => this.setState({ open: !open })}
        >
          {buttonTitle}
        </Button>
      </div>
    );
  }

  render() {
    const { error, title, cardClassName } = this.props;

    return (
      <div
        className={classnames(
          "ggcard-datepicker p-3 overflow-auto",
          cardClassName
        )}
      >
        <div className="d-flex flex-row mb-1">
          <h6 className="title flex-grow-1 mb-0">{title}</h6>
          {error && (
            <span className="error-message">
              <FontAwesomeIcon
                className="mr-1"
                icon={["fas", "exclamation-circle"]}
              />
              {error}
            </span>
          )}
        </div>
        <div className="mt-2">{this.renderSelectButton()}</div>
      </div>
    );
  }
}

export default DatePickerCard;



// WEBPACK FOOTER //
// ./src/common/DatePickerCard.component.tsx